var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c(
            "div",
            { staticClass: "flex justify-content-end gap mb-1" },
            [
              _c("LoadingButton", {
                staticClass: "btn btn-outline-danger",
                attrs: {
                  title: "Удалить выбранные",
                  loading: _vm.loading,
                  type: "button",
                  color: _vm.$constants.DANGER_COLOR,
                  onClick: () => _vm.deleteRecords(),
                },
              }),
              _vm._v(" "),
              _c("LoadingButton", {
                staticClass: "btn btn-outline-info",
                attrs: {
                  title: "Скачать выбранные",
                  loading: _vm.downloadLoading,
                  type: "button",
                  color: _vm.$constants.PRIMARY_COLOR,
                  onClick: () => _vm.downloadSelected(),
                },
              }),
              _vm._v(" "),
              _c("LoadingButton", {
                staticClass: "btn btn-outline-info",
                attrs: {
                  title: "Обновить",
                  loading: _vm.loading,
                  type: "button",
                  color: _vm.$constants.PRIMARY_COLOR,
                  onClick: () =>
                    _vm.getRecords(_vm.paginator?.current_page ?? 1),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading && _vm.files.length
            ? [
                _c(
                  "table",
                  { staticClass: "table mt-1 table-sm table-hover" },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th"),
                        _vm._v(" "),
                        _c("th", [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            on: { change: _vm.selectAll },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v("файл")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("скачан")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Создан")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Дата")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.files, function (r, i) {
                        return _c("tr", [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                i +
                                  1 +
                                  (_vm.paginator.current_page - 1) *
                                    _vm.paginator.per_page
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selected[r.id],
                                  expression: "selected[r.id]",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.selected[r.id])
                                  ? _vm._i(_vm.selected[r.id], null) > -1
                                  : _vm.selected[r.id],
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = _vm.selected[r.id],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.selected,
                                            r.id,
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.selected,
                                            r.id,
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.selected, r.id, $$c)
                                    }
                                  },
                                  function ($event) {
                                    return _vm.holdShift(r.id, $event)
                                  },
                                ],
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(r.file_name))]),
                          _vm._v(" "),
                          _c(
                            "td",
                            _vm._l(r?.details?.downloaded ?? [], function (d) {
                              return _c("p", [
                                _vm._v(
                                  "(" +
                                    _vm._s(d.user_id) +
                                    ") " +
                                    _vm._s(d.user_name) +
                                    "\n                "
                                ),
                                _c("span", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    "(" + _vm._s(_vm.printDate(d.date)) + ")"
                                  ),
                                ]),
                              ])
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(r.details?.uploaded_by?.user_name)),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.printDate(r.created_at))),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _vm.paginator
                ? _c("paginate", {
                    ref: "Pagination",
                    attrs: {
                      "page-count": _vm.paginator.last_page,
                      "page-range": 11,
                      "margin-pages": 2,
                      "click-handler": _vm.getRecords,
                      "prev-text": "&laquo",
                      "next-text": "&raquo",
                      "container-class": "pagination",
                      "prev-class": "page-item",
                      "prev-link-class": "page-link",
                      "page-class": "page-item",
                      "page-link-class": "page-link",
                      "next-class": "page-item",
                      "next-link-class": "page-link",
                      "active-class": "active green_btn",
                    },
                    model: {
                      value: _vm.paginator.current_page,
                      callback: function ($$v) {
                        _vm.$set(_vm.paginator, "current_page", $$v)
                      },
                      expression: "paginator.current_page",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }